import validateForms from "../functions/validate-forms.js";

export default function formValidation() {
  const reservationFormRules = [
    {
      ruleSelector: '[form-validate="reservation"] [input-validation="name"]',
      rules: [
        {
          rule: 'minLength',
          value: 3
        },
        {
          rule: 'required',
          value: true,
          errorMessage: 'Enter your name'
        }
      ]
    },
    {
      ruleSelector: '[form-validate="reservation"] [input-validation="tel"]',
      tel: true,
      telError: 'Enter correct phone number',
      rules: [
        {
          rule: 'required',
          value: true,
          errorMessage: 'Enter your phone'
        },
      ]
    },
    {
      ruleSelector: '[form-validate="reservation"] [input-validation="quantity"]',
      rules: [
        {
          rule: 'required',
          value: true,
          errorMessage: 'Enter number of people'
        },
      ]
    },
    {
      ruleSelector: '[form-validate="reservation"] [input-validation="date"]',
      date: true,
      dateError: 'Enter correct date',
      rules: [
        {
          rule: 'required',
          value: true,
          errorMessage: 'Choose date'
        },
      ]
    },
    {
      ruleSelector: '[form-validate="reservation"] [input-validation="time"]',
      time: true,
      timeError: 'Working time: 4pm — 1am',
      rules: [
        {
          rule: 'required',
          value: true,
          errorMessage: 'Choose time'
        },
      ]
    },

    {
      ruleSelector: '[form-validate="reservation"] [input-validation="privacy"]',
      rules: [
        {
          rule: 'required',
          value: true,
          errorMessage: 'Agree with privacy policy'
        }
      ]
    },
  ];


  function afterSend(form) {
    const thanks = form?.closest('.reservations-popup__form-wrapper').querySelector('[form-thanks]');
    form.style.opacity = '0',
    thanks.style.pointerEvents = 'auto',
    thanks.style.display = 'flex',

    setTimeout(()=>{
      thanks.style.pointerEvents = 'none',
      thanks.style.display = 'none',
      form.style.opacity = '1'
    }, 5000)
  }

  validateForms('[form-validate="reservation"]', reservationFormRules, [], afterSend);
}
